import { useEffect } from 'react';

export default function useScrollTop({
  data,
  resetOnDataLoad = true,
}: {
  data: any;
  resetOnDataLoad?: boolean;
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🔧 데이터 로딩 완료 후 스크롤 위치 재설정 (옵션)
  useEffect(() => {
    if (!resetOnDataLoad) return;
    if (data && data.length > 0) {
      // 데이터 로딩 완료 후 약간의 지연을 두고 스크롤 리셋
      const timer = setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [data, resetOnDataLoad]);

  // 🔧 추가적인 스크롤 리셋 (브라우저 스크롤 복원 방지)
  useEffect(() => {
    // 컴포넌트 마운트 후 여러 번 스크롤 리셋 시도
    const timers = [
      setTimeout(() => window.scrollTo(0, 0), 50),
      setTimeout(() => window.scrollTo(0, 0), 200),
      setTimeout(() => window.scrollTo(0, 0), 500),
    ];

    return () => {
      timers.forEach((timer) => clearTimeout(timer));
    };
  }, []);
}
